import type { ReactNode, VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { DependencyFilterKeys, DepthFilterOptions } from '../../../../../../shared/dependenciesV2';
import useFetchDependenciesAction from '../../hooks/useFetchDependencyAction';
import * as DependenciesV2Store from '../../../../../redux/dependenciesV2';
import FilterCardCheckboxes from '../../../../generic/Filter/FilterCardCheckboxes';
import type { SelectOption } from '../../../../../types';
import LabelWrapper from '../LabelWrapper';
import styles from '../Filters.module.less';
import { icons } from '../../../../generic/Icon';

// Filter labels by key value
const FILTER_LABELS: Record<DepthFilterOptions, ReactNode> = {
  [DepthFilterOptions.Direct]: <LabelWrapper className={styles.FilterIcon} icon={icons.box} label="Direct" />,
  [DepthFilterOptions.Transitive]: <LabelWrapper className={styles.FilterIcon} icon={icons.sitemap} label="Transitive" />,
};

// Built filter options for checkbox filter
const FILTER_OPTIONS: SelectOption[] = Object.entries(FILTER_LABELS).map(([value, label]) => ({
  label, value,
}));

/**
 * Depth filter which allows the user to filter dependencies by direct or transitive.
 * Uses DepthFilterOptions to generate the checkbox filter values.
 */
const DepthFilter: VoidFunctionComponent = () => {
  const filters = useSelector(DependenciesV2Store.selectors.getFilters);
  const setFilter = useFetchDependenciesAction(DependenciesV2Store.actions.setFilters);

  const selectedOptions = (filters.depth ?? []).map((option: DepthFilterOptions) => ({
    label: FILTER_LABELS[option],
    value: option,
  }));

  const onChange = (selected: SelectOption[]) => setFilter({
    ...filters,
    [DependencyFilterKeys.Depth]: selected.map((option) => option.value),
  });

  return (
    <FilterCardCheckboxes
      label="Depth"
      options={FILTER_OPTIONS}
      values={selectedOptions}
      onChange={onChange}
    />
  );
};

export default DepthFilter;
